import getIdForModel from "helpers/idHelper";

export const remapImpactLevels = (levels) => {
  if (!levels) {
    return [];
  }

  return levels.map((i) => (
    {
      amount: i.value.amount / 100,
      id: (getIdForModel(i.id) || null),
      title: i.label,
    }
  ));
};
